/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

/** Values shared by gallery list filter forms (URL-backed). */
export type GalleryListFilterFormValues = {
  mediaType: string
  nsfwRating: string
  sortBy?: string
}

export const DEFAULT_GALLERY_SORT_BY = 'LATEST'
export const DEFAULT_GALLERY_MEDIA_TYPE = 'ALL'
export const DEFAULT_GALLERY_NSFW_RATING = 'ALL'

export const GALLERY_MEDIA_SORT_VALUES = ['COMMENTS', 'LATEST', 'LIKES', 'OLDEST', 'VIEWS'] as const
export const GALLERY_MEDIA_TYPE_VALUES = ['IMAGE', 'VIDEO', 'UNDEFINED'] as const
export const GALLERY_NSFW_RATING_VALUES = ['SFW', 'SUGGESTIVE', 'EROTICA', 'EXPLICIT'] as const
export type GalleryNsfwFilterRating = (typeof GALLERY_NSFW_RATING_VALUES)[number]

/** Build filter form values from route-resolved search params. */
export function galleryListFilterFormValuesFromResolvedParams(params: {
  mediaType?: string
  nsfwRating?: string
  sortBy?: string
}): GalleryListFilterFormValues {
  return {
    mediaType: params.mediaType ?? DEFAULT_GALLERY_MEDIA_TYPE,
    nsfwRating: params.nsfwRating ?? DEFAULT_GALLERY_NSFW_RATING,
    sortBy: params.sortBy ?? DEFAULT_GALLERY_SORT_BY,
  }
}

export function galleryNsfwRatingSelectOptions(t: (key: string) => string): Array<{ label: string; value: string }> {
  return [
    { label: t('All'), value: 'ALL' },
    { label: t('Safe for Work'), value: 'SFW' },
    { label: t('Suggestive'), value: 'SUGGESTIVE' },
    { label: t('Erotica'), value: 'EROTICA' },
    { label: t('Explicit'), value: 'EXPLICIT' },
  ]
}
